import { Card, CardContent } from "../ui/card";

export function StatCard({ title, value, icon: Icon }) {
    return (
        <Card className="border-gray-200 bg-white hover:shadow-md transition-all">
            <CardContent className="p-5">
                <div className="flex flex-col">
                    <div className="flex items-center justify-between mb-3">
                        <div className="p-2 bg-red-50 rounded-lg">
                            <Icon className="h-5 w-5 text-red-600" />
                        </div>
                        <span className="text-2xl font-bold text-gray-900 tabular-nums">{value?.toLocaleString() || 0}</span>
                    </div>
                    <p className="text-xs font-medium text-gray-500 uppercase tracking-wide">{title}</p>
                </div>
            </CardContent>
        </Card>
    );
}
